import { Box, Chip, Grid } from "@mui/material";
import type { Theme } from "@mui/material";
import { useAssinatura } from "../../../../providers/assinaturaProvider";
import { SituacaoAssinatura } from "../../../../models/assinatura";
import { IconAward } from "@tabler/icons-react";
import CardMetodoDePagamento from "./cardMetodoDePagamento";
import CardAssinatura from "./cardAssinatura";
import CardInformacoesPessoais from "./cardInformacoesPessoais";
import CardInformacoesBusiness from "./cardInformacoesBusiness";
import PerfilSwitch from "../../../util/ui/switch/perfilSwitch";
import { useAssinar } from "../../assinatura/assine";

/** Situação da assinatura → uma das cinco cores semânticas do sistema. */
type StatusAssinatura = "positive" | "accent" | "warn" | "destructive";

const chipStatusSx =
  (status: StatusAssinatura) =>
  (theme: Theme) => ({
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.statusChip[status].bg,
    color: theme.palette.statusChip[status].fg,
    "& .MuiChip-icon": { color: "inherit" },
  });

export default function AbaAssinatura() {
  const assinatura = useAssinatura();
  const assinar = useAssinar();

  return (
    <Box>
      {(function () {
        if (!assinatura) {
          return (
            <Chip
              size="small"
              sx={chipStatusSx("accent")}
              label="ASSINAR"
              onClick={() => assinar()}
            />
          );
        }
        switch (assinatura.situacao) {
          case SituacaoAssinatura.ACTIVE:
            return (
              <Chip
                icon={<IconAward size={13} />}
                size="small"
                sx={chipStatusSx("positive")}
                label={`assinante desde ${assinatura.dataAssinatura.format(
                  "DD [de] MMMM [de] YYYY"
                )}`}
              />
            );
          case SituacaoAssinatura.TRIALING:
            return (
              <Chip
                size="small"
                sx={chipStatusSx("accent")}
                label={`em período de avaliação desde ${assinatura.dataAssinatura.format(
                  "DD [de] MMMM [de] YYYY"
                )}`}
              />
            );
          case SituacaoAssinatura.UNPAID:
          case SituacaoAssinatura.PAST_DUE:
          case SituacaoAssinatura.CANCELED:
          case SituacaoAssinatura.INCOMPLETE:
          case SituacaoAssinatura.INCOMPLETE_EXPIRED:
            return (
              <Chip
                size="small"
                sx={chipStatusSx("destructive")}
                label="Sua assinatura requer atenção"
              />
            );
          default:
            return;
        }
      })()}
      <Grid container spacing={2} alignItems="stretch">
        <Grid item lg={4} md={6} xs={12}>
          <PerfilSwitch
            renderContador={<CardInformacoesBusiness />}
            renderInvestidor={<CardInformacoesPessoais />}
          />
        </Grid>
        <Grid item lg={4} md={6} xs={12}>
          <CardAssinatura />
        </Grid>
        <Grid item lg={4} md={6} xs={12}>
          <CardMetodoDePagamento />
        </Grid>
      </Grid>
    </Box>
  );
}
